/* Probably Late — inner-page header: mobile hamburger menu.
   Mirrors the hero nav behaviour (clip-path wipe + staggered links). */
(function () {
  var burger = document.querySelector('.pl-head__burger');
  var menu = document.querySelector('.pl-head__mobile-menu');
  if (!burger || !menu) return;

  var links = Array.prototype.slice.call(menu.querySelectorAll('.pl-head__mobile-link'));
  var open = false;
  var tl = null;

  function buildTimeline() {
    var ease = 'power4.inOut';
    if (window.CustomEase) {
      gsap.registerPlugin(CustomEase);
      ease = CustomEase.create('plHeadMenu', '0.76, 0, 0.24, 1');
    }
    var t = gsap.timeline({
      paused: true,
      onReverseComplete: function () {
        menu.style.display = 'none';
      }
    });
    t.set(menu, { display: 'flex' });
    t.fromTo(menu, { clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0% 0)', duration: 0.65, ease: ease });
    t.fromTo(
      links,
      { y: 48, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.5, ease: 'power3.out', stagger: 0.06 },
      '-=0.3'
    );
    return t;
  }

  function setScrollLock(locked) {
    document.documentElement.style.overflow = locked ? 'hidden' : '';
    if (window.plLenis) {
      if (locked) window.plLenis.stop();
      else window.plLenis.start();
    }
  }

  burger.addEventListener('click', function () {
    open = !open;
    burger.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    setScrollLock(open);

    if (window.gsap) {
      if (!tl) tl = buildTimeline();
      if (open) tl.play();
      else tl.reverse();
    } else {
      menu.style.display = open ? 'flex' : 'none';
      menu.style.clipPath = 'inset(0 0 0% 0)';
    }
  });
})();
